/* angular:styles/component:css;6d22fcc4b3c04ff0a6f32418a643844f7a4261782b875390b027622e8a551af4;/src/src/app/shared/components/formly/formly-field-navigation/formly-field-navigation.ts */
::ng-deep formly-form {
  height: 100% !important;
}
.custom-title {
  color: var(--ion-text-color);
  font-size: 1.25rem;
  font-weight: 500;
}
/*# sourceMappingURL=formly-field-navigation.css.map */
